import { SVGProps } from '../types';

const EloIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M10.4326 12.661C10.8162 12.5352 11.2265 12.4669 11.6535 12.4669C13.5169 12.4669 15.0712 13.7654 15.4278 15.4903L18.0684 14.9622C17.4625 12.0305 14.821 9.82373 11.6535 9.82373C10.9283 9.82373 10.2302 9.93962 9.57861 10.1531L10.4326 12.661Z"
      fill="#FECA2F"
    />
    <path
      d="M7.28985 21.1569L8.87091 19.1155C8.16517 18.4016 7.71974 17.3595 7.71974 16.1978C7.71974 15.037 8.16476 13.9949 8.87029 13.2816L7.2884 11.2404C6.0892 12.4531 5.3335 14.2247 5.3335 16.1978C5.3335 18.172 6.0903 19.9441 7.28985 21.1569Z"
      fill="#1BA7DE"
    />
    <path
      d="M15.4286 16.907C15.0708 18.6316 13.5175 19.9285 11.6557 19.9285C11.2286 19.9285 10.8174 19.86 10.4338 19.7339L9.57861 22.243C10.2312 22.4575 10.9295 22.5736 11.6557 22.5736C14.8203 22.5736 17.4601 20.3683 18.0684 17.4378L15.4286 16.907Z"
      fill="#EC412A"
    />
    <path
      d="M27.4975 19.379C26.7836 20.0547 25.8013 20.4637 24.7241 20.4484C23.984 20.4373 23.2966 20.2261 22.7143 19.8702L23.5649 18.5607C23.9079 18.7706 24.3113 18.8964 24.7466 18.9034C25.3816 18.9122 25.9572 18.6696 26.3813 18.2706L27.4975 19.379ZM30.7729 18.4952L32.0747 19.0177L31.4585 20.4484L30.1714 19.9308C29.8819 19.8094 29.6855 19.624 29.5366 19.4152C29.3938 19.2015 29.2877 18.9096 29.2876 18.5157V11.2404H30.7729V18.4952ZM39.9995 17.4445C39.638 19.1584 38.0696 20.4484 36.1909 20.4484C35.7597 20.4483 35.3452 20.3804 34.9575 20.255L35.4653 18.7872C35.6934 18.8609 35.9372 18.9015 36.1909 18.9015C37.2963 18.9015 38.2196 18.1422 38.4321 17.1339L39.9995 17.4445ZM34.6753 15.0353C34.2026 15.4401 33.9048 16.0318 33.9048 16.6906C33.9049 17.3499 34.2031 17.9417 34.6763 18.3468L33.6167 19.505C32.812 18.8164 32.3053 17.8112 32.3052 16.6906C32.3052 15.5712 32.8109 14.5646 33.6147 13.8761L34.6753 15.0353ZM24.8413 12.9337C26.661 12.9613 28.1689 14.1939 28.5649 15.8331L21.5268 18.7413C21.1182 18.1371 20.8855 17.4102 20.8979 16.6329C20.9303 14.5583 22.6975 12.9021 24.8413 12.9337ZM24.8188 14.4796C23.5557 14.4594 22.5148 15.435 22.4946 16.6573C22.4921 16.7471 22.4987 16.8362 22.5083 16.923L26.5288 15.2638C26.1162 14.7929 25.506 14.4886 24.8188 14.4796ZM36.1909 12.9327C38.0712 12.9327 39.6396 14.224 39.9995 15.9396L38.4321 16.2491C38.2208 15.2393 37.2973 14.4796 36.1909 14.4796C35.9375 14.4796 35.6939 14.5191 35.4663 14.5929L34.9595 13.1251C35.346 13.0003 35.7601 12.9328 36.1909 12.9327Z"
      fill="black"
    />
  </svg>
);

export { EloIcon };
